import React, { useState, useEffect, useCallback } from "react";
import { Button, Form } from "react-bootstrap";
import CommentBox from "./CommentBox.js";

// defines a React functional component called CommentForm.
// takes a single prop called teamId as an argument using destructuring assignment.
const CommentForm = ({teamId}) => {
  
  // email is a state variable that stores user's email
  const [email, setEmail] = useState(""); 

  
  // comment is a state variable that stores comment text
  const [comment, setComment] = useState(""); 
  
  
  // comments is a state variable stores an array of retrieved comments for the teams
  const [comments, setComments] = useState([]); 

// function to update comments
// retrieves data and updates the comment state
// defines a function  and takes a single arugement named data
  const updateComments = (data) => { 

    // this logs data to the console 
    console.log(data); 
    
    // updates the comment state with the value of the data arugement
    setComment(data);
  };

  
  
  // Function to fetch comments from the backend API
  // Defines a function called fetchComments using the useCallback hook.
  // useCallback ensures the function's identity remains stable and doesn't change on every re-render unless the dependencies change.
  const fetchComments = useCallback(() => {
    
    // Checks if the teamId state variable exist and is truthy 
    if (teamId) {  
    
      // If teamId exists, constructs the API URL by adding the teamId to the endpoint
      // Uses the fetch API to send a GET request to the constructed URL.
      teamId && fetch(`https://zbsports-api.ue.r.appspot.com/api/comments/${teamId}`)

      // Handles the succesful response from the API
      // Parases/determine the repsonse body as JSON
      .then(res => res.json())
      
      // Processes the parsed JSON Data
      .then(data => {
        
        // logs the data to the console 
        console.log(data)
       

        // updates the comments state variable with the recieved data.
        setComments(data); 
      })

      // handles any error during fetching
      // logs the error message to the console
      .catch(err => console.error('Error fetching comments:', err));
    }

      // Defines the dependency array for the useCallback hook
      // Specifies that the fetchComments function should pnly be recreated when the teamId state changes 
  },[teamId]);

  


// Runs a side effect after the component mounts or when the dependencies fetchComment and teamId in the second argument change.
  useEffect(() => {


    // Calls the fetchComments function, passing the updateComments function as an argument. 
    // Tells fetchComments that it should use the updateComments function to update the comment state when new data is received.
    fetchComments(updateComments); 

    // Dependacy array for the useEffect hook 
    // Specifies that useEffect hook should run again when fetchComments or teamId State changes
  }, [fetchComments, teamId]);


  // Defines a function called handleSubmit that is triggered when the form is submitted.
  const handleSubmit = (event) => {

    // This line prevents the default form submission behavior, which is typically to reload the page.
    event.preventDefault();

    // Sends Post request to the backend api to submit a new comment 
    fetch(`https://zbsports-api.ue.r.appspot.com/api/comments/${teamId}`, {
   
      // object that defines the config options for the fetch request and sets the content type header to application/json
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },

      // An object defines the body of the POST request. It converts the email and comment state variables to a JSON string and sends them to the API.
      body: JSON.stringify({ email, comment }),
    })

      // This code handles the successful response from the API. It parses the response body as JSON.
      .then(res => res.json())

      // This line logs the successful comment submission message to the console and displays the data received from the API.
      .then(data => {
        console.log('Comment submitted successfully:', data);
      })
      
      // This code handles any errors during submitting the comment. It logs the error message to the console.
      .catch(err => console.error('Error submitting comment:', err));


    // Clear the form after submission by resetting the email and comment state varible to empty strings
    setEmail('');
    setComment('');
  };



  
  return (
    
    // wraps this the form and its components in a div 
    // This function will be called whenever the user submits the form.
    // className="mb-3" adds a margin-bottom style to the group.controlId="exampleForm.ControlInput1" sets a unique identifier for the group, making it accessible to assistive technologies.

    // type="email" specifies the input type as email, validating the format of the entered text.
    // placeholder="name@example.com" displays a placeholder text when the field is empty.
    // value={email} binds the value of the input field to the email state variable in the component.
    // onChange={(e) => setEmail(e.target.value)} defines a function that updates the email state variable with the new value as the user types.
    //name="email" assigns a unique name to the input field for identification purposes.
    // This element defines the submit button for the form:type="submit" specifies that the button will trigger the form submission. The text displayed on the button is "Post".
   // The closing tags </Form> and </div> mark the end of the form and container element, respectively.


      
    <div> 
      <Form onSubmit={handleSubmit}>
        <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
          <Form.Label>Email address</Form.Label>
          <Form.Control
            type="email"
            placeholder="name@example.com"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            name="email"
          />
        </Form.Group>
        <Form.Group className="mb-3" controlId="exampleForm.ControlTextarea1">
          <Form.Label>Comment</Form.Label>
          <Form.Control
            as="textarea"
            rows={3}
            value={comment}
            onChange={(e) => setComment(e.target.value)}
            name="comments"
          />
        </Form.Group>

        <Button type="submit">Post</Button>

        {comments && <CommentBox comments = {comments}/>}
      </Form>
    </div>
      // CommentBox 
      // Uses conditonal rendering to display the commentbox componenet only if the comment state variable holds data
      // If comment exists the CommentBox component is rendered and recieves comment as props. if no comment nothing is rendered
  )

}

export default CommentForm;

